/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Fab, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { deletedRequirement } from "src/stateManagement/redux/slices/location/asyncReducers";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { ActiveActivityDto, AddRequirements, RequirementDto } from "./add_requeriments/AddRequirements";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';

export const Requerimientos = () => {
    const dispatch = useDispatch();
    const { requirements, locationId, locationName } = useSelector((state) => state.location);

    const columns: GridColDef[] = [
        { field: "requiredDate", headerName: "Fecha Solicitado ", flex: 1 },
        { field: "activity", headerName: "Tipo de Actividad", flex: 1 },
        { field: "requiredBy", headerName: "Solicitado por", flex: 1 },
        { field: "status", headerName: "Estado", flex: 1 },
        { field: "comments", headerName: "Comentario", flex: 1 },
        { field: "executedDate", headerName: "Fecha Ejecutado", flex: 1 },
        {
            field: "actions",
            headerName: "",
            width: 100,

            renderCell: (params) => {
                return (
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                        <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteRequirement(params.row.optimizationActivityId,params.row.variableId)}
                        >
                            <DeleteForeverIcon fontSize="medium" />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleEditRow(params.row.optimizationActivityId)}
                        >
                            <EditIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                );
            },
        },
    ];

    const [showAddRequirements, setShowAddRequirements] = useState(false);

    const [activeActivity, setActiveActivity] = useState<ActiveActivityDto|undefined>(undefined)

    const handleDeleteRequirement = (
        optimizationActivityId: string,
        variableId: string
    ) => {
        Swal.fire({
            title: "Estas seguro?",
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SI, eliminar!",
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    optimizationActivityId,
                    variableId,
                };

                dispatch(deletedRequirement(data, locationId));

                Swal.fire({
                    title: "Eliminado!",
                    icon: "success",
                });
            }
        });
    };

    const handleShowAddActivity = () => {
        setShowAddRequirements(!showAddRequirements);
    };

    const handleEditRow = (optimizationActivityid: string) => {

        
        const requirementsActivities = requirements.filter(x=>x.optimizationActivityId === optimizationActivityid)
        
        if (requirementsActivities.length === 0) return;

        const ActiveRequirements:RequirementDto[] = []

        requirementsActivities.forEach((item) => {
            const { variableId, activity, status,blocker, comments } = item;
            const requirement: RequirementDto = {
                id: variableId,
                location:locationName,
                name:activity,
                value: 'Si',
                type:'Requirement',
                comments,
                blocker,
                status:status,
            };
            ActiveRequirements.push(requirement);
        });

        const activeActivity: ActiveActivityDto = {
            optimizationActivityId: requirementsActivities[0].optimizationActivityId,
            requirements: ActiveRequirements,
            requiredUserId: requirementsActivities[0].requiredById,
            requiredDate: requirementsActivities[0].requiredDate
        }

        setActiveActivity(activeActivity);
        setShowAddRequirements(true);        
    }

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <>
            {showAddRequirements && (
                <AddRequirements
                    show={showAddRequirements}
                    setShowPendingActivities={setShowAddRequirements}
                    TabDisable={true} 
                    activeActivity={activeActivity}
                    setActiveActivity={setActiveActivity}
                />
            )}
            <Grid>
                <Grid size={12}>
                    <DataGrid
                        rows={requirements}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            border: 0,
                            mt: 2,
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#316EBC",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                        }}
                        getRowId={(row) =>
                            row.optimizationActivityId + row.variableId
                        }
                    />
                </Grid>
                <Grid
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 2,
                    }}
                >
                    <Fab
                        size="medium"
                        color="primary"
                        aria-label="add"
                        onClick={
                            handleShowAddActivity
                        }
                    >
                        <AddIcon />
                    </Fab>
                </Grid>
            </Grid>
        </>
    );
};
